// @ts-nocheck
import React from 'react';
import { SearchOutlined } from '@mui/icons-material';
import '../styles/SearchBar.css';
import { CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SearchIcon } from './Icons/index';
import { Option } from '@src/interfaces/type';
import LabeledSelectField from './CustomSelect/LabeledSelectField';
import styled from 'styled-components';

const StyledContainer = styled.div({
	display: 'flex',
});

export type Props = {
	style?: any;
	value: string;
	onChange?: (text) => void;
	isLoading: boolean;
	placeholder?: string;
	filters?: Option[];
	onSelectChange?: any;
	selectedSearchFilter?: string;
	autoFocus?: boolean;
};

const SearchBar: React.FC<Props> = ({
	style = {},
	value,
	onChange,
	isLoading,
	placeholder,
	filters,
	onSelectChange,
	selectedSearchFilter,
	autoFocus = false,
}) => {
	const { t } = useTranslation();

	const handleChange = (event) => {
		onChange(event?.target?.value);
	};

	if (filters?.length) {
		const handleSelectChange = (event: SelectChangeEvent<unknown>) => {
			const selectedValue = event.target.value as string;
			onSelectChange(selectedValue);
		};
		return (
			<div style={style} className="searchBar__searchContainer">
				<LabeledSelectField
					value={selectedSearchFilter}
					placeholder="Search By"
					options={filters}
					handleChange={handleSelectChange}
					styles={{ width: '120px', height: '36px', marginRight: '10px' }}
				/>
				<input
					style={{ color: 'var(--color-font-grey)', border: 'none', width: '384px' }}
					placeholder={placeholder ?? t('Search...')}
					type="text"
					value={value}
					onChange={handleChange}
					autoFocus={autoFocus}
				/>
			</div>
		);
	}
	return (
		<div style={style} className="searchBar__search">
			<div className="searchBar__searchContainer">
				{isLoading ? (
					<CircularProgress />
				) : (
					<SearchIcon className="searchBar__searchContainer__searchIcon" />
					// <SearchOutlined className="searchBar__searchContainer__searchIcon" />
				)}

				<input
					style={{ color: 'var(--color-font-grey)' }}
					placeholder={placeholder ?? t('Search...')}
					type="text"
					value={value}
					onChange={handleChange}
					autoFocus={autoFocus}
				/>
			</div>
		</div>
	);
};

export default SearchBar;
